import SingleCategorySelector from "@components/plasmic/custom-options/category-selector/single-category-selector";

import { CUSTOM, DEFAULT, PL_04, PRODUCT_LISTING_CAROUSEL_VARIANT } from "@helpers/plasmic/slices";
import { DEFAULT_PRODUCT_COUNT } from "@helpers/plasmic/products";

import {
  FILTER_OPTIONS,
  URL_TYPE_OPTIONS,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  CATEGORY_HOME_LINK_TYPE,
  OTHER_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

const hidePropsIfNoViewTypeIsProvided = (props) => !props.viewType;

export const ProductListingCarouselPlasmicProps = {
  className: {
    type: "string",
    defaultValue: "",
  },
  identifier: {
    type: "string",
    hidden: (props) => hidePropsIfNoViewTypeIsProvided(props) || props.viewType === DEFAULT,
  },
  variant: {
    type: "choice",
    options: PRODUCT_LISTING_CAROUSEL_VARIANT,
    defaultValue: PL_04,
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
  categorySlug: {
    type: "custom",
    control: SingleCategorySelector,
    description: "Select a category to filter products in the carousel",
    defaultValue: "",
    hidden: (props) => hidePropsIfNoViewTypeIsProvided(props) || props.viewType === CUSTOM,
  },
  filterOptions: {
    type: "choice",
    options: FILTER_OPTIONS,
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
  productCount: {
    type: "number",
    defaultValue: DEFAULT_PRODUCT_COUNT,
    hidden: (props) => hidePropsIfNoViewTypeIsProvided(props),
  },
  viewType: {
    type: "choice",
    options: [
      {
        label: DEFAULT,
        value: DEFAULT,
      },
      {
        label: CUSTOM,
        value: CUSTOM,
      },
    ],
  },
  title: {
    type: "string",
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
  description: {
    type: "string",
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
  showBadgesAndColorOptions: {
    type: "boolean",
    description: "Show badges and color options for the product",
    helpText:
      "By Default, badges and color options are not shown. If you want to show them, enable this option.",
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
  btnText: {
    type: "string",
    hidden: hidePropsIfNoViewTypeIsProvided,
  },

  btnLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
  btnLinkOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hidePropsIfNoViewTypeIsProvided(props) ||
      (props.btnLinkType !== OTHER_LINK_TYPE && props.btnLinkType !== EXTERNAL_LINK_TYPE),
  },
  btnLinkCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hidePropsIfNoViewTypeIsProvided(props) ||
      (props.btnLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.btnLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  linkToNewTab: {
    type: "boolean",
    defaultValue: false,
    hidden: hidePropsIfNoViewTypeIsProvided,
  },
};
